TYPE_PEOPLE_LIST